import { Trash2, Inbox, Pencil } from "lucide-react";
import { inr, fmtDate } from "../lib/api";

export const EntriesTable = ({ entries, branchMap, onDelete, onEdit }) => {
  if (!entries.length)
    return (
      <div className="bg-surface border border-dashed border-line2 p-10 text-center" data-testid="entries-empty">
        <Inbox className="h-8 w-8 mx-auto text-muted-c" />
        <p className="mt-2 text-sm text-muted-c">No entries for this selection</p>
      </div>
    );
  return (
    <div className="bg-surface border border-line overflow-x-auto" data-testid="entries-table">
      <table className="w-full text-sm min-w-[820px]">
        <thead className="bg-head border-b border-line">
          <tr className="font-mono text-[11px] uppercase tracking-wider text-muted-c text-left">
            <th className="px-4 py-3">Date</th><th className="px-4 py-3">Branch</th><th className="px-4 py-3">Description</th>
            <th className="px-4 py-3">Mode</th><th className="px-4 py-3 text-right">Deposit</th>
            <th className="px-4 py-3 text-right">Withdraw</th><th className="px-4 py-3">Created by</th>{(onEdit || onDelete) && <th className="px-2 py-3" />}
          </tr>
        </thead>
        <tbody>
          {entries.map((e) => {
            return (
              <tr key={e.id} className="border-b border-line/60 row-hover group" data-testid="ledger-entry-row">
                <td className="px-4 py-3 font-mono whitespace-nowrap">{fmtDate(e.date)}</td>
                <td className="px-4 py-3">{branchMap[e.branch_id] || "-"}</td>
                <td className="px-4 py-3 text-ink2">{e.description || "-"}</td>
                <td className="px-4 py-3"><span className="text-xs border border-line px-2 py-0.5">{e.mode}</span></td>
                <td className="px-4 py-3 text-right font-mono text-pos">{e.type === "deposit" ? inr(e.amount) : ""}</td>
                <td className="px-4 py-3 text-right font-mono text-neg">{e.type === "withdraw" ? inr(e.amount) : ""}</td>
                <td className="px-4 py-3 text-xs text-muted-c whitespace-nowrap" data-testid={`entry-created-by-${e.id}`}>{e.created_by_name || "Admin"}</td>
                {(onEdit || onDelete) && <td className="px-2 py-3 whitespace-nowrap">
                  {onEdit && <button onClick={() => onEdit(e)} className="p-1 text-muted-c hover:text-brand transition-colors" data-testid={`edit-entry-${e.id}`} aria-label="Edit entry">
                    <Pencil className="h-4 w-4" />
                  </button>}
                  {onDelete && <button onClick={() => onDelete(e)} className="p-1 text-muted-c hover:text-neg transition-colors" data-testid={`delete-entry-${e.id}`} aria-label="Delete entry">
                    <Trash2 className="h-4 w-4" />
                  </button>}
                </td>}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
